import { AxiosError } from 'axios';
import { HttpError } from '../error/httpError';

const errorInterceptor = (error: AxiosError): Promise<HttpError> => {
  return Promise.reject(new HttpError(error));
};

export default errorInterceptor;
